import { connect } from 'react-redux';
import SessionHandler from './session-handler.component';

const mapStateToProps = ({ player, firebase }) => ({
  userId: firebase?.auth?.uid,
  isPlaying: player.isPlaying,
});

export default connect(mapStateToProps)(SessionHandler);
